import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'ScoreIndicator' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 16
    },
    score: {
        width: 48,
        fontSize: 14,
        fontWeight: 800,
        lineHeight: '24px',
        color: 'inherit'
    },
    dots: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 54
    },
    dot: {
        width: 8,
        height: 8,
        borderRadius: 4,
        background: `repeating-linear-gradient(
            135deg,
            #fff,
            #fff 4px,
            #fafafa 4px,
            #fafafa 8px
          )`
    },
    _highlighted: {
        background: 'currentColor'
    },
    _low: {
        color: '#05A569'
    },
    _medium: {
        color: '#EB8F01'
    },
    _high: {
        color: '#EB8F01'
    },
    _critical: {
        color: '#F5726A'
    }
});
